import { useLazyQuery, useQuery } from "@apollo/client";
import { ARTICLE } from "../article.queries";
import { ArticleQuery, ArticleQueryVariables } from "../../../__generated__/ArticleQuery";

export const useArticle = (id: number) => {
  return useQuery<ArticleQuery, ArticleQueryVariables>(ARTICLE, { variables: { id } });
};

export const useLazyArticle = () => {
  return useLazyQuery<ArticleQuery, ArticleQueryVariables>(ARTICLE);
};
